import { render } from "./ProductGroupList.vue?vue&type=template&id=4ed8f8ac&scoped=true&ts=true"
import script from "./ProductGroupList.vue?vue&type=script&lang=ts"
export * from "./ProductGroupList.vue?vue&type=script&lang=ts"

import "./ProductGroupList.vue?vue&type=style&index=0&id=4ed8f8ac&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed8f8ac"]])

export default __exports__